'use client';

import { Button, Element } from '@/components/core';
import ErrorPage from '@/components/core/components/organism/error-page';
import InternalLink from '@/components/core/components/organism/internal-link';
import { useLocalizedLinks } from '@/components/core/hooks';
import { Trans } from '@lingui/react/macro';
import { useEffect } from 'react';

const Error = ({ error }: { error: Error & { digest?: string } }) => {
  const links = useLocalizedLinks();
  useEffect(() => {
    console.error(error);
  }, [error]);
  return (
    <ErrorPage>
      <span>🤔</span>
      <Element as="h1" typography="title">
        <Trans>Oops! Something went wrong, please try again later.</Trans>
      </Element>
      <p>
        <Trans>Sorry about that, it looks like an unexpected error occurred. What can you do?</Trans>
      </p>
      <ul className="flex flex-col gap-2 list-disc">
        <li>
          <Trans>Try refreshing the page.</Trans>
        </li>
        <li>
          <Trans>Check back later, this might be a temporary issue.</Trans>
        </li>
      </ul>
      <Button as={InternalLink} variant="primary" href={links.root()}>
        <Trans>Return Home</Trans>
      </Button>
    </ErrorPage>
  );
};

export default Error;
